export const getGroupById = (id, groups) => {
  let selected = { id: '0' };

  groups.forEach((groupItem) => {
    if (groupItem.id === id) {
      selected = groupItem;
    }
  });

  return selected;
};

export const formatError = (error) => {
  const errorMessage = error.message;
  const addInfo = JSON.stringify(error.response.data);
  return `${errorMessage} \n ${addInfo}`;
};

export const ISO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_FORMAT = 'YYYY-MM-DD';
